<template>
    <div class="tab-detail">
        <div class="header">
            <div class="title">{{ $t("googlePlay.channelDetails") }}</div>
        </div>
        <div class="form-content">
            <a-form-item :label="$t('googlePlay.channelName')">
                <a-input v-model="localChannel.name" />
            </a-form-item>
            <a-form-item :label="$t('googlePlay.status')">
                <a-switch v-model="localChannel.enabled" />
                <span class="status-text">{{ localChannel.enabled ? $t("googlePlay.enabled") : $t("googlePlay.disabled") }}</span>
            </a-form-item>
            <div class="form-actions">
                <a-button type="primary" @click="save" :loading="saving">
                    {{ $t("googlePlay.save") }}
                </a-button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";
import _ from "lodash";

export default {
    name: "UpdateDetail",
    props: {
        value: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            localChannel: _.cloneDeep(this.value),
            saving: false,
        };
    },
    methods: {
        ...mapActions({
            updateChannel: "channel/updateChannel",
        }),
        async save() {
            this.saving = true;
            try {
                await this.updateChannel({
                    _id: this.localChannel._id,
                    name: this.localChannel.name,
                    enabled: this.localChannel.enabled,
                });
                this.$message.success(this.$t("googlePlay.channelUpdated"));
                this.$emit("saved");
            } catch (err) {
                this.$message.error(this.$t("googlePlay.errorUpdatingChannel"));
            } finally {
                this.saving = false;
            }
        },
    },
    watch: {
        value: {
            handler(newVal) {
                this.localChannel = _.cloneDeep(newVal);
            },
            deep: true,
        },
    },
};
</script>

<style lang="scss" scoped>
.tab-detail {
    padding: 20px;

    .header {
        padding-bottom: 15px;
        border-bottom: 1px solid var(--color-border-default);
        margin-bottom: 20px;

        .title {
            font-size: 18px;
            font-weight: 700;
            color: var(--color-text-strong-default);
        }
    }

    .form-content {
        max-width: 500px;

        .status-text {
            margin-left: 10px;
        }

        .form-actions {
            margin-top: 20px;
        }
    }
}
</style>
